export default __webpack_public_path__ + "static/viz/media/neo4j.040dfb8c.svg";